import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import useToken from '../../useToken';
import { useAuth } from '../../contexts/AuthContext'
import { useSelector, useDispatch } from 'react-redux';
import { fetchRecords } from '../../features/cultivation_report/cultivationRecordsSlice';
import Table from './CultivationTable';
import { Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import {  MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { endOfMonth, startOfMonth, subYears, subMonths } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import * as CsvExporter from '../../CsvExporter'
import { CSVLink } from "react-csv";

const theme = createTheme({
  palette: {
    primary: { main: "#657a71", contrastText: "#fff" },
  },
});
const useStyles = makeStyles ({
      root: {
              display: 'flex',
            },
      toolbar: {
              paddingRight: 24, // keep right padding when drawer closed
            },
      toolbarIcon: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              padding: '0 8px',
            },
      menuButton: {
              marginRight: 36,
            },
      menuButtonHidden: {
              display: 'none',
            },
      title: {
              flexGrow: 1,
            },
      content: {
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            },
      container: {
              paddingTop: 1,
              paddingBottom: 1,
            },
      paper: {
              display: 'flex',
              flexDirection: 'column',
            },
      fixedHeight: {
              height: 400,
            },
      formControl: {
        margin: 10,
        marginLeft: 30,
        minWidth: 300,
      },
      buttonMargin: {
        marginTop: 20,
      },
      selectEmpty: {
        marginTop: 10,
      },
      link: {
        textDecoration: 'none', 
        color: "#657a71",
        marginRight: 20,
        margin:10,
        border:1 ,  
      }
});

const CultivationRecords = () => {
  const [crop, setCrop] = React.useState("Xiao Bai Cai")
  
  const {token, setToken} = useToken()
  const dispatch = useDispatch()
  const { logout } = useAuth()
  const [operationId, setOperationId] = React.useState("")

  const records = useSelector((state: any) => state.cultivation_records.recordData);
  const [selectedFromDate, setSelectedFromDate] = React.useState(
    startOfMonth(subMonths(new Date(),1),1)  );
  const [selectedToDate, setSelectedToDate] = React.useState(
    endOfMonth(new Date())
  );
  const [csvData, setCsvData] = React.useState({filename:"", data:""})

  useEffect(() => {
      dispatch(fetchRecords({token, crop, selectedFromDate, selectedToDate}))
    }, [dispatch]);

  if (records.error === "unauthorized") {
      logout()
      window.location.reload();
  }

    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    
    const handleCrop = (event) => {
      setCrop(event.target.value)
      const { type, checked, name, value } = event.target;
      const crop = value
      dispatch(fetchRecords({token, crop, selectedFromDate, selectedToDate, operationId}))
    }

    const handleSelectFrom = (newFromDate) => {
      if (newFromDate < selectedToDate) {
        setSelectedFromDate(newFromDate)
        const selectedFromDate = newFromDate
        dispatch(fetchRecords({token, crop, selectedFromDate, selectedToDate, operationId}))
      } else {
        alert("From date is newer than To date.")
      }
    }

    const handleSelectTo = (newToDate) => {
      if (newToDate > selectedFromDate) { 
        setSelectedToDate(newToDate)
        const selectedToDate = newToDate
        dispatch(fetchRecords({token, crop, selectedFromDate, selectedToDate, operationId}))
      }else {
        alert("To date is older than From date.")
      }
    }

    const handleOperationId = (event) => {
      if (event.target.value === "") {
        alert("Operation Id is empty.")
      } else {
        console.log(event.target.value)
        setOperationId(event.target.value)
      }
    }

    const reset = () => {
      setOperationId("")
      var newOperationId = ""
      dispatch(fetchRecords({token, crop, selectedFromDate, selectedToDate, newOperationId}))
    }

    const exportCSV = CsvExporter.getCultivationRecords({records: records.TopTenYields})

    if (records.status === "idle") { 
        return (
         <Container maxWidth="lg" className={classes.container}>
         <h1>Cultivation Records</h1>

         <Grid container>
         <Grid item xs={4}>
         <FormControl className={classes.formControl}>
         <InputLabel id="crop-label">Select crop</InputLabel>
         <Select
          labelId="crop-label"
          id="crop"
          value={crop}
          onChange={handleCrop}
         >
          { 
              records.crops.map((crop, index) => {
                return <MenuItem key={index} value={crop}>{crop}</MenuItem>
              }
          )}
        </Select>
        </FormControl>
        </Grid>
        <Grid item xs={4}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={theme}>
        <DatePicker
          variant="inline"
          label="From"
          format="yyyy-MM-dd"
          value={selectedFromDate}
          helperText="Start from harvest date"
          onChange={handleSelectFrom}
        />  
        </ThemeProvider>
        </MuiPickersUtilsProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={theme}>
        <DatePicker
          variant="inline"
          label="To"
          format="yyyy-MM-dd"
          value={selectedToDate}
          helperText="End from harvest date"
          onChange={handleSelectTo}
        />
        </ThemeProvider>  
        </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={3}>
        <ThemeProvider theme={theme}>
          <Button className={classes.buttonMargin} variant="contained" 
          color="primary" onClick={reset} >Search</Button>
        </ThemeProvider>
        </Grid>
        </Grid>
        <hr/>
        <Grid container>
          <Grid item xs={6}>        
            <FormControl className={classes.formControl}>
              <TextField variant="outlined" value={operationId} onChange={handleOperationId} label="Search for id" />
            </FormControl>
          <ThemeProvider theme={theme}>
          <Button className={classes.buttonMargin} variant="contained" 
          color="primary" onClick={() => dispatch(fetchRecords({token, crop, selectedFromDate, selectedToDate, operationId}))} >Search</Button>
          </ThemeProvider>
          </Grid>
        </Grid>
        <hr/>
         <Grid container>
         <Grid item xs={12}>
         <Paper className={fixedHeightPaper}>
         <Grid container justifyContent="flex-end">
            <CSVLink className={classes.link} 
              filename={exportCSV.filename}
              headers={exportCSV.header}
              data={exportCSV.data}>
              <Button variant="outlined">Export CSV</Button>
            </CSVLink>
         </Grid>
            <Table data={records.TopTenYields} />
         </Paper>
         </Grid>
         </Grid>
         <Box pt={4}>
         </Box>
         </Container>

        )
    } else {
      return (<h3> loading </h3>)
    }
  }

export default CultivationRecords
